/*! Hammer.JS - v2.0.8 - 2016-04-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.8",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
//# sourceMappingURL=hammer.min.js.map
const updateAllCurrencies = () => {
  try {
    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val())
  }
  catch(e) {

  }
}
const Carousel = {
    init($document, selector = '.cCarousel') {
        this.selector = selector
        this.indicatorSelector = `${selector}-indicator`
        this.itemSelector = `${selector}-item`
        this.itemContainerSelector = `${selector}-content`
        this.arrowSelector = `${selector}-control`
        this.$document = $document
        $document.on('click', this.indicatorSelector, (e) => {
            const $el = $(e.currentTarget)
            $el.blur()
            const index = $el.attr('data-index')
            const $carousel = $el.closest(this.selector)
            this.gotoSlide($carousel, index * 1)
            $carousel.find(this.arrowSelector).removeClass('disabled').attr('tabindex', 0)
            if ($carousel.find(this.indicatorSelector).filter(':visible').last().is($el)) {
              $carousel.find(`${this.arrowSelector}--next`).addClass('disabled').attr('tabindex', -1)
            }
            if ($carousel.find(this.indicatorSelector).filter(':visible').first().is($el)) {
              $carousel.find(`${this.arrowSelector}--prev`).addClass('disabled').attr('tabindex', -1)
            }
        })
        $document.on('click', this.arrowSelector, (e) => {
          const $el = $(e.currentTarget)
          $el.blur()
          const $carousel = $el.closest(this.selector)
          const direction = $el.is(`${this.arrowSelector}--prev`) ? 'prev' : 'next'
          const $active = $carousel.find(this.indicatorSelector).filter('.active').filter(':visible')
          let $next = $active.nextAll(':visible').first()
          if (!$next.length) {
            $next = $carousel.find(this.indicatorSelector).filter(':visible').first()
          }
          let $prev = $active.prevAll(':visible').first()
          if (!$prev.length) {
            $prev = $carousel.find(this.indicatorSelector).filter(':visible').last()
          }
          if (direction === 'prev') {
            $prev.trigger('click')
          } else {
            $next.trigger('click')
          }
        })
        this.$document.find(this.selector).each((i, el) => {
            $(el).find(this.indicatorSelector).first().trigger('click')
        })
        this.$document.find(this.selector).filter(':first-child').each((i, el) => {
          $(el).trigger('click')
        })
        this.$document.find(this.selector).each((i, el) => {
            $(el).find(this.indicatorSelector).first().trigger('click')
            const hammertime = new Hammer($(el).get(0), {})
            hammertime.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
            hammertime.on('swipeleft swiperight', (ev) => {
              const $carousel = $(ev.target).closest(this.selector)
              $carousel.find(`${this.arrowSelector}--${ev.type === 'swiperight' ? 'prev' : 'next'}`).trigger('click')
            })
        })
    },
    gotoSlide($carousel, index) {
        const $slideContainer = $carousel.find(this.itemContainerSelector)
        const $slide = $slideContainer.find(this.itemSelector).eq(index)

        if (!$slide.length) {
          return;
        }

        const $first = $slideContainer.find(this.itemSelector).first()
        const marginLeft = ($first.css('marginLeft').split('px')[0])*1
        $first.css('marginLeft', 0)
        const offset = $slide.position().left;
        const width = $slideContainer.width()
        $first.css('marginLeft', marginLeft)
        let speed = $carousel.attr('data-speed')
        speed = speed ? speed * 1 : 'fast'

        $first.animate({
            marginLeft: -offset
        }, speed, () => {
            $first.css('marginLeft', 0)
            $slideContainer.find(this.itemSelector).each((i, el) => {
                const $el = $(el)
                const elWidth = $el.width()
                const elOffset = $el.position().left
                const visible = elOffset >= offset && ($el.position().left + elWidth) <= (width + offset)
                const $indicator = $carousel.find(this.indicatorSelector).filter(`[data-index="${i}"]`)
                if (visible) {
                    $indicator.addClass('active')
                    $el.addClass('active')
                    $el.children('.cProductCard').children('a').attr('tabindex', 0)
                    $el.children('.cProductCard').children('.cProductCard-content').children('.cProductCard-variants').attr('tabindex', 0)
                    $el.children('.cProductCard').children('.cProductCard-content').children('.cProductCard-variants').children('.cProductCard-variant').attr('tabindex', 0)
                } else {
                    $indicator.removeClass('active')
                    $el.removeClass('active')
                    $el.children('.cProductCard').children('a').attr('tabindex', -1)
                    $el.children('.cProductCard').children('.cProductCard-content').children('.cProductCard-variants').attr('tabindex', -1)
                    $el.children('.cProductCard').children('.cProductCard-content').children('.cProductCard-variants').children('.cProductCard-variant').attr('tabindex', -1)
                }
            })
            $first.css('marginLeft', -offset)
        })

    }
}

const RecentlyViewed = {
    init($document, selector = '.cRV') {
        this.selector = selector
        this.indicatorSelector = `${selector}-indicator`
        this.itemSelector = `${selector}-item`
        this.itemContainerSelector = `${selector}-content`
        this.arrowSelector = `${selector}-control`
        this.$document = $document
        $document.on('click', this.indicatorSelector, (e) => {
            const $el = $(e.currentTarget)
            $el.blur()
            const index = $el.attr('data-index')
            const $carousel = $el.closest(this.selector)
            this.gotoSlide($carousel, index * 1)
            $carousel.find(this.arrowSelector).removeClass('is-hidden').attr('tabindex', 0);
            if ($carousel.find(this.indicatorSelector).filter(':visible').last().is($el)) {
              $carousel.find(`${this.arrowSelector}--next`).addClass('is-hidden').attr('tabindex', -1)
            }
            if ($carousel.find(this.indicatorSelector).filter(':visible').first().is($el)) {
              $carousel.find(`${this.arrowSelector}--prev`).addClass('is-hidden').attr('tabindex', -1)
            }
        })
        $document.on('click', this.arrowSelector, (e) => {
          const $el = $(e.currentTarget)
          $el.blur()
          const $carousel = $el.closest(this.selector)
          const direction = $el.is(`${this.arrowSelector}--prev`) ? 'prev' : 'next'
          const $active = $carousel.find(this.indicatorSelector).filter('.active').filter(':visible')
          let $next = $active.nextAll(':visible').first()
          if (!$next.length) {
            $next = $carousel.find(this.indicatorSelector).filter(':visible').first()
          }
          let $prev = $active.prevAll(':visible').first()
          if (!$prev.length) {
            $prev = $carousel.find(this.indicatorSelector).filter(':visible').last()
          }
          if (direction === 'prev') {
            $prev.trigger('click')
          } else {
            $next.trigger('click')
          }
        })
        this.$document.find(this.selector).each((i, el) => {
            $(el).find(this.indicatorSelector).first().trigger('click')
        })
        this.$document.find(this.selector).filter(':first-child').each((i, el) => {
          $(el).trigger('click')
        })
        this.$document.find(this.selector).each((i, el) => {
            $(el).find(this.indicatorSelector).first().trigger('click')
            const hammertime = new Hammer($(el).get(0), {})
            hammertime.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
            hammertime.on('swipeleft swiperight', (ev) => {
              const $carousel = $(ev.target).closest(this.selector)
              $carousel.find(`${this.arrowSelector}--${ev.type === 'swiperight' ? 'prev' : 'next'}`).trigger('click')
            })
        })
    },
    gotoSlide($carousel, index) {
        const $slideContainer = $carousel.find(this.itemContainerSelector)
        const $slide = $slideContainer.find(this.itemSelector).eq(index)

        if (!$slide.length) {
          return;
        }

        const $first = $slideContainer.find(this.itemSelector).first()
        const marginLeft = ($first.css('marginLeft').split('px')[0])*1
        $first.css('marginLeft', 0);
        const offset = $slide.position().left;
        const width = $slideContainer.width()
        $first.css('marginLeft', marginLeft)
        let speed = $carousel.attr('data-speed')
        speed = speed ? speed * 1 : 'fast'

        $first.animate({
            marginLeft: -offset
        }, speed, () => {
            $first.css('marginLeft', 0)
            $slideContainer.find(this.itemSelector).each((i, el) => {
                const $el = $(el)
                const elWidth = $el.width()
                const elOffset = $el.position().left
                const visible = elOffset >= offset && ($el.position().left + elWidth) <= (width + offset)
                const $indicator = $carousel.find(this.indicatorSelector).filter(`[data-index="${i}"]`)
                if (visible) {
                    $indicator.addClass('active')
                    $el.addClass('active')
                  $el.children('.cProductCard').children('a').attr('tabindex', 0)
                } else {
                    $indicator.removeClass('active')
                    $el.removeClass('active')
                    $el.children('.cProductCard').children('a').attr('tabindex', -1)
                }
            })
            $first.css('marginLeft', -offset)
        })

    }
}

const Cart = {
  queue: [],
  inProgress: false,

  process() {
    if (this.queue.length > 0) {
      this.inProgress = true

      const reqOptions = {}

      const queueItem = this.queue.shift()
      const type = queueItem[0]
      const data = queueItem[1]
      const cb = queueItem.length > 2 ? queueItem[2] : null

      const reqCallback = (reqData) => {
        this.inProgress = false
        const args = []
        if (reqData && reqData.responseJSON) {
          args.push(reqData.responseJSON)
        }

        const processedEvent = $.Event('213a_cart_processed', {
          cart: args.length > 0 ? args[0] : null,
          action: type,
          actionData: data
        })
        $(document).trigger(processedEvent)

        if (cb != null) {
          cb(...args)
        }
        this.process()
      }

      reqOptions.complete = reqCallback
      reqOptions.data = data
      reqOptions.dataType = 'json'
      switch (type) {
        case 'update':
          reqOptions.url = '/cart/update.js'
          reqOptions.method = 'POST'

          break
        case 'get':
          reqOptions.url = '/cart.js'
          reqOptions.method = 'GET'

          break
        case 'add':
          reqOptions.url = '/cart/add.js'
          reqOptions.method = 'POST'

          break
        default:
          console.error('Unknown `type` within Cart Queue `process`', type, queueItem)
          return
      }

      $.ajax(reqOptions)
    }
  },

  push(type, data, cb = null) {
    this.queue.push([type, data, cb])
    if (!this.inProgress) {
      this.process()
    }
  },

  update(id, data = null, cb = null) {
    if ($.isArray(id)) {
      this.batchUpdate(id)
      return
    }

    let postData = data == null || $.isNumeric(data) ? {} : data

    if ($.isNumeric(data)) {
      postData = {
        updates: {
        }
      }
      postData.updates[id] = data
    }
    this.push('update', postData, cb)
  },

  change(id, data = null, cb = null) {
    let postData = data == null ? {} : data
    if ($.isNumeric(postData)) {
      postData = {
        quantity: postData
      }
    }
    postData.id = id
    this.push('change', postData, cb)
  },

  get(cb) {
    this.push('get', null, cb)
  },

  add(id, data = null, cb = null) {
    let postData = data == null ? {} : data
    if ($.isNumeric(postData)) {
      postData = {
        quantity: postData
      }
    }
    postData.id = id
    this.push('add', postData, cb)
  },

  batchUpdate(items = [], cb = null) {
    const postData = {
      updates: {}
    }

    items.forEach((item) => {
      postData.updates[item.id] = item.quantity
    })

    this.push('update', postData, cb)
  },

  batchUpdateLines(items = [], cb = null) {
    const postData = {
      updates: items
    }
    this.push('update', postData, cb)
  }
}

const MiniCart = {
  $document: null,
  cart: null,
  splitValue: '<!-- CART_SPLIT_VALUE -->',
  init($document, selector = '.cSideCart', cart) {
    this.$document = $document ? $document : $(document)
    this.$el = this.$document.find(selector)
    this.selector = selector
    this.cart = cart ? cart : Cart
    const inputSelector = `.cCartItem-qtyField`
    const buttonSelector = `.cCartItem-qtyBtn`
    const removeSelector = `.cCartItem-remove`
    const upsellSelector = `.cCartUpsell-cta`
    if (`${window.location.hash}`.indexOf('#cart') === 0) {
      $('#cSideCart-toggle').prop('checked', true)
    }
    $document.on('213a_cart_processed', (e) => {
      const cartFixKey = '_cartFix'
      if (e && e.action && (e.action === 'update' || e.action === 'get')) {
        if (e.actionData && e.actionData[cartFixKey]) {
          return
        }
        this.update(e.cart)
      }
    })
    $document.on('change', inputSelector, (e) => {
      const $this = $(e.currentTarget)
      const itemId = $this.closest('[data-id]').attr('data-key')
      const lineKey = $this.closest('[data-line-key]').attr('data-line-key')
      const $items = $this.closest('[data-id]').parent().find(`>[data-line-key="${lineKey}"]`)
      const itemIds = []
      $items.each((i, el) => itemIds.push($(el).attr('data-key')))
      this.$el.addClass('loading')
      this.cart.update(itemIds.map((item) => {
        return {
          id: item,
          quantity: $this.val() * 1
        }
      }), $this.val() * 1, (cartData) => {
        this.updateCallback()(cartData)
      })
    })
    $document.on('click', upsellSelector, (e) => {
      const $this = $(e.currentTarget)
      const itemId = $this.closest('[data-id]').attr('data-id')
      this.$el.addClass('loading')
      this.cart.add(itemId, 1, (cartData) => {
        this.updateCallback()(cartData)
      })
    })
    $document.on('click', buttonSelector, (e) => {
      const $this = $(e.currentTarget)
      const $field = $this.closest('[data-id]').find(inputSelector)
      const modifier = $this.attr('data-value') * 1
      let newValue = $field.val() * 1 + modifier
      newValue = newValue > 0 ? newValue : 0
      $field.val(newValue).trigger('change')
    })
    $document.on('click', removeSelector, (e) => {
      const $this = $(e.currentTarget)
      const $field = $this.closest('[data-id]').find(inputSelector)
      $field.val(0).trigger('change')
    })
  },
  updateCallback() {
    return (data) => {
      this.update(data)
    }
  },
  update() {
    const cartUrl = `/cart?t=${new Date()}`
    $.get(cartUrl, (html) => {
      const parts = html.split(this.splitValue)
      this.$document.find(`${this.selector}-container`).html(parts[1])
      this.$el.removeClass('loading')
      const count = (this.$document.find(`${this.selector}-container`).find('.cSideCart-icon').attr('data-count') || 0) * 1
      const $icon = $('.bag-icon')
      $icon.find('.items').remove()
      $icon.find('svg path').first().removeAttr('class')
      if (count > 0) {
        $('<div />').text(count).addClass('items').appendTo($icon.find('a'))
        $icon.find('svg path').first().attr('class', 'full')
      }
      updateAllCurrencies()
    });
  }
}

const Cookies = {
  get(cookieName) {
    const cookies = this.getCookies()
    if (typeof cookies[cookieName] !== 'undefined') {
      return cookies[cookieName]
    }
    return null
  },

  set(key, value, expires = null, path = '/', domain = null) {
    let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    if (expires != null) {
      const date = new Date()
      date.setTime(date.getTime() + (expires * 60 * 60 * 1000))
      cookie = `${cookie}; expires=${date.toUTCString()}`
    }

    if (path !== null) {
      cookie = `${cookie}; path=${path}`
    }
    if (domain !== null) {
      cookie = `${cookie}; domain=${domain}`
    }
    document.cookie = cookie
  },
  unset(key) {
    this.set(key, '', -24 * 365 * 20)
  },
  getCookies() {
    let cookies = document.cookie
    cookies = cookies.split(';')
    const cookieJar = {}

    cookies.forEach((cookie) => {
      const values = cookie.split('=')
      let cName = values.length > 0 ? values.shift() : ''
      let cValue = values.length > 0 ? values.join('=') : ''
      try {
        const decodedValue = decodeURIComponent(cValue)
        cValue = decodedValue
      } catch (e) {
        console.warn('Could not decode cookie value', cookie)
      }

      try {
        const decodedValue = decodeURIComponent(cName)
        cName = decodedValue
      } catch (e) {
        console.warn('Could not decode cookie name', cookie)
      }
      cName = $.trim(cName)
      cValue = $.trim(cValue)
      cookieJar[cName] = cValue
    })
    return cookieJar
  }
}

const Webcam = {
  fakeCallback: () => {
  },
  turnOn(container = '#pupil-distance-box', _cb){
    this.turnOff()
    const cb = _cb && _cb.call ? _cb : this.fakeCallback
    const $container = $(container)
    $container.find('video,canvas').remove()
    const $video = $('<video />')
    const $canvas = $('<canvas />').attr('style', 'opacity:0; position: absolute; top:-100vh; left:-100vw; pointer-events: none')
    $canvas.appendTo($container)
    $video.appendTo($container)
    $video.attr('playsinline', 'playsinline').attr('autoplay', 'autoplay').removeAttr('controls').attr('style', 'width: 100%; height:100%; object-fit: cover;')
    this.$video = $video
    this.$canvas = $canvas
    this.canvas = $canvas.get(0)
    this.video = $video.get(0)
    const constraints = {
      audio: false,
      video: true
    }
    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      this.stream = stream
      this.video.srcObject = this.stream;
      cb(true)
    }).catch(() => {
      cb(false)
    })
  },
  turnOff(_cb) {
    const cb = _cb && _cb.call ? _cb : this.fakeCallback
    if (!this.stream) {
      cb(true)
      return
    }
    const tracks = this.stream.getTracks()
    tracks.forEach((track) => {
      track.stop()
    })
    this.video.srcObject = null
  },
  snap(cb) {
    this.canvas.width = this.video.videoWidth
    this.canvas.height = this.video.videoHeight
    this.canvas.getContext('2d').drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height)
    cb(this.canvas.toDataURL('image/jpeg', 1.0))
  }
}

const Collection = {
  init($document, selector = '.cCollection') {
    this.$document = $document ? $document : $(document)
    this.selector = selector

    if ($(`${selector}`).is('[data-expand="true"]')) {
      this.duplicate()
    }
    this.initSecret()
    this.createFilters()
  },
  initSecret() {
    const $collection = this.$document.find(this.selector)
    if ($collection.is('[data-secret="true"]')) {
      const flashSaleEmail = window.localStorage && window.localStorage.getItem('flashSaleEmail')
      if (flashSaleEmail) {
        $collection.removeAttr('data-secret')
      } else {
        $('.cCollectionEmail').addClass('open')
      }
      $('.cCollectionEmail form').on('submit', (e) => {
        e.preventDefault()
        const $el = $(e.currentTarget)
        const $input = $el.find('.cCollectionEmail-input')
        if ($input.val() && $input.val().indexOf('@') > 0) {
          $('.cCollectionEmail').addClass('loading')
          const post = {
            email: $input.val(),
            g: $el.attr('data-list-id')
          }
          $.ajax({
              method: 'POST',
              url: '//manage.kmail-lists.com/ajax/subscriptions/subscribe',
              data: post,
              complete(xhr) {
                $('.cCollectionEmail').removeClass('open').removeClass('loading')
                $collection.removeAttr('data-secret')
                const storage = window.localStorage && window.localStorage.setItem('flashSaleEmail', '1')
              }
            })
          }
        })
    }
  },
  duplicate(productSelector = '.cCollection-products .cProductCard') {
    const configObject = $('.cCollection[data-color-limit]').attr('data-color-limit')
    let config = {}
    try {
      config = JSON.parse(configObject)
    } catch(e) {}
    if (config && config.colors && config.colors.length) {
      config.colors = config.colors.map(c => c.split(',').map(cc => `${this.handleize(cc.trim())}${cc.indexOf('*') >= 0 ? '*' : ''}`))
      config.global_colors = (config.global_colors || '').trim().split(',').map(cc => `${this.handleize(cc.trim())}${cc.indexOf('*') >= 0 ? '*' : ''}`)
      config.map = {}
      config.colors.forEach((c, idx) => config.map[config.handles[idx]] = c)
    }
    const $cards = this.$document.find(this.selector).find(productSelector)
    $cards.each((i, el) => {
      const $el = $(el)
      const $variants = $el.find('.cProductCard-variants > *')
      const handle = $(el).attr('data-handle')
      $variants.each((i2, el2) => {
        const allowedColors = (config && config.global_colors || []).concat((config && config.map && config.map[handle] && config.map[handle]) || [])
        let allow = true
        let currentColor = this.handleize(`${$(el2).attr('data-subtitle')}`)

        if (allowedColors.length > 0) {
          allow = allowedColors.find((c) => (c.indexOf('*') >= 0 && currentColor.indexOf(this.handleize(c)) >= 0) || currentColor === c)
        }
        if (!allow) {
          return
        }
        const $newEl = $el.clone(true)
        $newEl.insertBefore($el)
        $newEl.find('.cProductCard-variants > *').eq(i2).trigger('click')
      })
      $el.remove()
    })
  },
  handleize(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '')
  },
  createFilters(productSelector = '.cCollection-products .cProductCard') {
    const allTags = []
    const $cards = this.$document.find(this.selector).find(productSelector)
    $cards.each((i, el) => {
      let attrTags = $(el).attr('data-tags') || '[]'
      let tags = JSON.parse(attrTags)
      tags.forEach((tag) => {
        if(allTags.indexOf(tag) === -1) {
          allTags.push(tag)
        }
      })
    });

    const filters = window.filterConfig || [];

    allTags.forEach((tag) => {
      let parts = tag.split(':')
      let type = `${parts.shift()}`.toLowerCase()
      parts = parts.join(':')
      filters.forEach((filter) => {
        if (filter.id == type) {
          let shouldAdd = true
          if (filter.limit && filter.limit.length) {
            shouldAdd = false
            filter.limit.forEach((limit) => {
              let _limit = limit.toLowerCase()
              if (parts.toLowerCase().indexOf(_limit) >= 0) {
                shouldAdd = true
                parts = limit
              }
            })
          }
          filter.values.forEach((val) => {
            let _val = val.toLowerCase()
            if (_val == parts.toLowerCase()) {
              shouldAdd = false
            }
          })
          if (shouldAdd) {
            filter.values.push(parts)
          }
        }
        filter.values.sort((a, b) =>  a.toLowerCase().localeCompare(b.toLowerCase()))
      })
    })
    let optionCount = 0;
    const markup = `
        <fieldset class="cCollectionFilters">
          <legend class="cCollectionFilters-title">Filter by:</legend>
          <div class="cCollectionFilters-categories">
            ${filters.map((filter) =>
              !filter.values.length ? '' : `
                <input name="cCollection-activeCategory" type="checkbox" id="cCollection--${filter.id}" tabindex="0" aria-label="Search by ${filter.label}" />
                <label for="cCollection--${filter.id}" class="cCollectionFilters-category" data-category="${filter.id}">${filter.label}</label>
                <div class="cCollectionFilters-categoryOptions">
                  ${filter.values.map((value, idx) => {
                    let tagParts = value.split(':');
                    let tag = tagParts[tagParts.length - 1].trim(); // Extract last part of tag (e.g., 'Cat Eye')
      
                    // Convert tag name to match filename format
                    let formattedTag = tag.replace(/\s+/g, '_'); // "Cat Eye" -> "Cat_Eye"
      
                    // Extract icons array properly (Check if filter.icons exists and is an array)
                    let iconList = (Array.isArray(filter.icons) && filter.icons.length > 0) ? filter.icons[0].icons : [];
      
                    // Convert Shopify media GID to an image URL
                    let matchedIcon = iconList.find(iconGid => iconGid.includes(`${formattedTag}`));
                    
                    let imageUrl = Array.isArray(filter.icons) && filter.icons.length > 0 
                      ? `https://cdn.shopify.com/s/files/1/2483/1234/files/${formattedTag}.png`
                      : '';
      
                    let optionImg = imageUrl 
                      ? `<img src="${imageUrl}" alt="${tag} Icon" width="35" class="cCollection-FilterIcon" />`
                      : '';
      
                    optionCount += 1;
                    console.log(iconList)
                    
                    return `
                      <div class="cCollectionFilters-option" style="align-items: flex-start;">
                        <input type="checkbox" id="cCollection--${filter.id}-${idx}" 
                               data-tag="${value.replace(/"/g, '&quot;')}" 
                               data-type="${filter.id}" tabindex="0" 
                               aria-label="Select ${tag}" />
                        ${optionImg}
                        <label for="cCollection--${filter.id}-${idx}">${tag}</label>
                      </div>
                    `;
                  }).join('')}
                </div>
              `
            ).join('')}
            <div class="cCollectionFilters-actions" data-filters="">
              <button type="button" aria-label="Clear filters" class="cCollectionFilters-action cCollectionFilters-action--clear" tabindex="0">Clear filters</button>
              <button type="button" aria-label="Apply filters" class="cCollectionFilters-action cCollectionFilters-action--apply" tabindex="0">Shop</button>
            </div>
          </div>
          <div class="cCollectionFilters-matches" data-count="${$cards.length}">Pairs</div>
        </fieldset>
      `;
      if (optionCount > 1) {
        $('.cCollection-filters').html(markup)
        this.applyFilters()
      }
      $('.cCollection-filters .cCollectionFilters-option input').on('change', (e) => {
        this.applyFilters()
      })
      $('.cCollection-filters .cCollectionFilters-categories input[name="cCollection-activeCategory"]').on('change', (e) => {
        const $el = $(e.currentTarget)
        $('.cCollection-filters .cCollectionFilters-categories input[name="cCollection-activeCategory"]').not($el).prop('checked', false)
      })
      $('.cCollectionFilters-action--apply').on('click', (e) => {
        $('.cCollectionFilters').removeClass('open')
      })
      $('.cCollectionFilters-title').on('click', (e) => {
        $('.cCollectionFilters').toggleClass('open')
      })      
      $('.cCollectionFilters-action--clear').on('click', (e) => {
        $('.cCollection-filters .cCollectionFilters-option input:checked').prop('checked', false).first().trigger('change')
        $('.cCollectionFilters').removeClass('open')
        $('.cCollectionStaticImage').css('display', 'block')
      })
      $('#cCollection--').on('keypress', (e) => {
        const $el = $(e.currentTarget)
        if (event.key === "Enter") {
          $el.not($el).trigger('click')
        }
      })
      $('.cCollection-filters .cCollectionFilters-categories input[name="cCollection-activeCategory"]').on('keypress', (e) => {
        const $el = $(e.currentTarget)
        if (event.key === "Enter") {
          $('.cCollection-filters .cCollectionFilters-categories input[name="cCollection-activeCategory"]').not($el).prop('checked', false)
        }
      })
      $('.cCollectionFilters-action--apply').on('keypress', (e) => {
        if (event.key === "Enter") {
          $('.cCollectionFilters').removeClass('open')
        }
      })
      $('.cCollectionFilters-title').on('keypress', (e) => {
        if (event.key === "Enter") {
          $('.cCollectionFilters').toggleClass('open')
        }
      })
      $('.cCollectionFilters-action--clear').on('keypress', (e) => {
        if (event.key === "Enter") {
          $('.cCollection-filters .cCollectionFilters-option input:checked').prop('checked', false).first().trigger('change')
          $('.cCollectionFilters').removeClass('open') 
          $('.cCollectionStaticImage').css('display', 'block')
        }
      })
  },
  applyFilters(productSelector = '.cCollection-products .cProductCard') {
    const filters = {}
    const appliedTags = []
    $('.cCollection-filters .cCollectionFilters-option input:checked').each((i, el) => {
      const $el = $(el)
      filters[$el.attr('data-type')] = filters[$el.attr('data-type')] || []
      filters[$el.attr('data-type')].push($el.attr('data-tag'))
      appliedTags.push($el.attr('data-tag'))
      $('.cCollectionStaticImage').css('display', `${Boolean(filters) ? 'none' : 'block'}`)
    })
    $('.cCollectionFilters-actions').attr('data-filters', appliedTags.join(', '))
    // console.log('Active filters', filters)
    const $cards = this.$document.find(this.selector).find(productSelector)
    const matches = []
    $cards.each((i, card) => {
      const $card = $(card)
      $card.attr('data-matches', '0')
      let cardMatches = true
      const cardTags = JSON.parse($card.attr('data-tags'))
      Object.keys(filters).forEach((type) => {
        let foundCount = 0
        filters[type].forEach((tag) => {
          const fixedTag = `${type}:${tag}`.toLowerCase()
          cardTags.forEach((cardTag) => {
            foundCount += cardTag.toLowerCase() == fixedTag ? 1 : 0
          })
        })
        cardMatches = cardMatches && foundCount > 0
      })
      if (cardMatches) {
        matches.push($card)
        $card.attr('data-matches', '1')
      }
    })
    $cards.each((i, card) => {
      const $card = $(card)
      $card[$card.is('[data-matches="1"]') ? 'fadeIn' : 'fadeOut']('fast')
    })
    $('.cCollectionFilters-matches').attr('data-count', matches.length)
    setTimeout(() => {
      $(window).trigger('scroll')
    }, 500)
  }
}

const AnimaScroll = {
  instances: [],
  hooked: false,
  triggered: false,
  $window: {},
  init(element, _options = null) {
    const options = Object.assign({}, _options)
    options.callback = typeof options.callback !== 'undefined' ? options.callback : _options

    const instance = {
      $el: $(element),
      options
    }
    this.instances.push(instance)
    this.maybeHook()
  },
  requestLoop() {
    window.requestAnimationFrame(() => {
      this.loop()
    })
  },
  loop() {
    if (!this.triggered) {
      this.requestLoop()
      return
    }
    this.triggered = false

    this.instances.forEach((instance) => {
      if (!instance.$el || !instance.$el.length) {
        return
      }
      instance.$el.each((i, el) => {
        const $el = $(el)
        const options = instance.options ? instance.options : {}
        if ($el.is('[data-animascroll-triggered]')) {
          return // The animation was already triggered (or queued if there is adelay)
        }
        let threshold = options.threshold ? options.threshold : null
        threshold = $el.is('[data-animascroll-threshold]') ? $el.attr('data-animascroll-threshold') : threshold

        if (threshold) { // Threshold should be calculated
          const $thresholdElement = $('<div />').css('height', threshold)
          threshold = $thresholdElement.outerHeight()
        }

        let delay = options.delay ? options.delay : null
        delay = $el.is('[data-animascroll-delay]') ? $el.attr('data-animascroll-delay') : delay
        const callback = options.callback ? options.callback : this.mock

        if (!threshold || threshold === 'auto') {
          threshold = $el.offset().top
        //   + $el.height()
          + -this.$window.outerHeight()
        }
        if (this.$window.scrollTop() > threshold) {
          $el.attr('data-animascroll-triggered', 'true')
          if (delay) {
            setTimeout(() => {
              $el.addClass('animated')
              callback($el)
            }, delay * 1)
          } else {
            $el.addClass('animated')
            callback($el)
          }
        }
      })
    })
    this.requestLoop()
  },
  mock() {
    // Mock callback
  },
  maybeHook() {
    if (this.hooked) {
      return
    }
    this.hooked = true
    this.$window = $(window)
    this.triggered = true
    this.$window.on('scroll', () => {
      this.triggered = true
    })
    this.loop()
  }
}

// 
// const TryOn = {
//   init() {
//     this.dittoCreation = null;
//     this.dittoTryOn = null;
//     this.allowedSkus = []
//     this.accessKey = '';
//     this.signature = '';
//     this.called = false;

//     this.updateCredentials(() => {
//       this.updateSkus(() => {
//         this.hook()
//       })
//     })
//   },
//   updateCredentials(cb) {
//     $.get("/tools/token/ditto-auth-credentials/", (res) => {
//       this.accessKey = res['X-Ditto-Access-Key-Id']
//       this.signature = res['X-Ditto-Signature']
//       return cb && cb.call ? cb() : null
//     })
//   },
//   updateSkus(cb) {
//     $.ajax({
//       dataType: "json",
//       url: 'https://vto.partners.api.ditto.com/api/1.3/products',
//       success: (data) => {
//         console.log('data!', data)
//         if (data && data.ids && data.ids.length) {
//           this.allowedSkus = data.ids
//         }
//         return cb && cb.call ? cb() : null
//       },
//       headers: {
//         'X-Ditto-Access-Key-Id': this.accessKey,
//         'X-Ditto-Signature': this.signature,
//       }
//     });
//   },
//   hook() {
//     const $button = $('.cProduct-tryon, a[href *= "#tryon"')
//     let sku = '';
//     if ($button && $button.attr('data-sku')) {
//       sku = $button.attr('data-sku')
//     } else if($button && ('' + $button.attr('href')).indexOf('#tryon:') !== -1) {
//       sku = $button.attr('href').split('#tryon:').pop()
//     }
//     if (!sku || this.allowedSkus.indexOf(sku) === -1) {
//       return
//     }
//     this.sku = sku
//     $button.addClass('active')
//     $button.on('click', () => this.createModal())
//   },
//   createModal(embedUrl) {
//     let called = false;
//     const acceptedTAC = Boolean(localStorage.getItem('ditto_tac') === 'accepted');
//     const dialogId = `cModal_${(new Date()).getTime()}`
//     const markup = `
//       <div class="cModalContainer cModalContainer--vimeo cModalContainer--ditto">
//         <input type="checkbox" class="cModal-toggler" id="${dialogId}" />
//         <div class="cModal cModal--lg cModal--video">
//           <label for="${dialogId}" class="cModal-backdrop"></label>
//           <div class="cModal-window">
//             <label for="${dialogId}" class="cModal-close">&times;</label>
//             <div class="cModal-content">
//               <div class="cModal-title"></div>
//               <div class="cModal-ditto">
//                 <div class="cModal-dittoLegal">
//                   <h2 class="cModal-dittoTitle">${window._dittoSettings.title}</h2>
//                   <div class="cModal-dittoText">${window._dittoSettings.text}</div>
//                   <div class="cModal-dittoLegal"><label><input type="checkbox" /> ${window._dittoSettings.legal}</label></div>
//                   <button type="button" class="cModal-dittoButton">${window._dittoSettings.cta}</button>
//                 </div>
//                 <div id="creation"></div>
//                 <div id="ditto" style="display: none; margin:0 auto;">
//                   <button id="restart-ditto" type="button">${window._dittoSettings.restart}</button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>`

//     const $dialog = $(markup)
//     $dialog.find('.cModal-toggler').prop('checked', true).on('change', () => {
//       if (this.dittoCreation && this.dittoCreation.destroy) {
//         this.dittoCreation.destroy()
//       }
//       if (this.dittoTryOn && this.dittoTryOn.destroy) {
//         this.dittoTryOn.destroy()
//       }
//     })
//     var $oldDialog = $('.cModalContainer--ditto')
//     if ($oldDialog && $oldDialog.length) {
//       $oldDialog.remove()
//     }
//     if ($dialog != null) {
//       $dialog.remove()
//     }
//     var self = this
//     $dialog.appendTo('body')
//     var $legal = $dialog.find('.cModal-dittoLegal')
//     var $ditto = $dialog.find('#creation')
//     $ditto.css('position', 'absolute')
//     $dialog.find('.cModal-dittoButton').on('click', function(e) {
//       e.preventDefault()
//       var $check = $dialog.find('.cModal-dittoLegal input')
//       if ($check.is(':checked')) {
//         $ditto.fadeTo(0, 0.0001);
//         $legal.fadeTo('fast', 0, function() {
//           $legal.hide()
//           if (!called) {
//             self.createDitto.call(self)
//           }
//           called = true
//           $ditto.css('position', 'relative')
//           $ditto.fadeTo('fast', 1)
//           $dialog.attr('data-ditto', '1')
//         })
//         localStorage.setItem('ditto_tac', 'accepted')
//       }
//     });

//     $dialog.find('#restart-ditto').on('click', () => {
//       this.refersh();
//     });

//     this.$dialog = $dialog

//     if (acceptedTAC) {
//       if (!called) {
//         self.createDitto.call(self);
//       }
//       called = true
//       $legal.hide();
//       $ditto.css('position', 'relative').show();
//       $dialog.attr('data-ditto', '1');
//     }

//     return $dialog
//   },
//   createDitto() {
//     var $dialog = this.$dialog;
//     var tryOn = null;
//     this.$dialog.find('iframe').remove();
//     var tryOnCallback = (callbackObject) => {
//       $('#creation').addClass('ditto-hidden')
//       $('#ditto').show();
//       tryOn = new ditto.api.TryOn({
//         serverNetloc: "https://vto.partners.api.ditto.com",
//         partnerId: "illesteva",
//         selector: "#ditto",
//         dittoId: callbackObject.dittoId,
//         sku: this.sku,
//         accessKeyId: this.accessKey,
//         signature: callbackObject.signature
//       })
//     }
//     try {
//       var now = new Date()
//       var data = JSON.parse(window.localStorage.getItem('ditto_data'))
//       if (data && data.time > (now.getTime() - 60*60*1000)) {
//         tryOnCallback(data)
//         return
//       }
//     } catch(e) {
//       console.log(e)
//     }
//     this.dittoCreation = new ditto.api.DittoCreation(
//       {
//         selector: '#creation',
//         accessKeyId: this.accessKey,
//         clientSignature: this.signature,
//         serverNetloc: "https://vto.partners.api.ditto.com",
//         partnerId: "illesteva"
//       },
//       {
//         success: (callbackObject) => {
//           console.log("success", callbackObject);
//           try {
//             callbackObject.time = (new Date()).getTime();
//             window.localStorage.setItem('ditto_data', JSON.stringify(callbackObject))
//           } catch(e) {
//             console.log(e)
//           }
//           tryOnCallback(callbackObject)
//         },
//         failure: function(callbackObject) {
//           console.log("failure", callbackObject);
//         },
//         progress: function(callbackObject) {
//           console.log("progress", callbackObject);
//         },
//         close: function(callbackObject) {
//           console.log("close", callbackObject);
//           if (tryOn) {
//             tryOn.destroy()
//           }
//           $dialog.find('.cModal-toggler').prop('checked', false).trigger('change')
//         }
//       }
//     );
//   },
//   refersh() {
//     window.localStorage.removeItem('ditto_data');
//     this.createModal();
//   },
// }
// 

const ProductCard = {
  init($document, selector = '.cProductCard') {
    this.$document = $document ? $document : $(document)
    this.selector = selector
    this.variantSelector = `${selector}-variants > ${selector}-variant`
    this.navSelector = `${selector}-nav > *`
    // console.log('SELECTOR', this.navSelector)
    this.imageSelector = `${selector}-image`
    this.subtitleSelector = `${selector}-subtitle`

    this.$document.find(this.variantSelector).on('click', (e) => {
      e.preventDefault()
      const $el = $(e.currentTarget)
      const $card = $el.closest(this.selector)
      const tag = $el.data('tag')
      const imageHover = $el.attr('data-image2')

      $el.blur()
      $card.find(this.imageSelector).attr('src', `${$el.attr('data-image')}`)
      $card.find(`${this.imageSelector}--hover`)
        .attr('src', `${imageHover}`)
        .css('display', `${Boolean(imageHover) ? 'block' : 'none'}`)
        .css('opacity', `${Boolean(imageHover) ? '0' : '1'}`)
        .on('mouseover', (e) => {
          // e.preventDefault()
          $card.find(`${this.imageSelector}--hover`).css('opacity', '1')
        })
        .on('mouseout', (e) => {
          // e.preventDefault()
          $card.find(`${this.imageSelector}--hover`).css('opacity', '0')
        })
        .on('touchmove', (e) => {
          $card.find(`${this.imageSelector}--hover`).css('opacity', '1')
        })
        .on('touchcancel', (e) => {
          // e.preventDefault()
          $card.find(`${this.imageSelector}--hover`).css('opacity', '0')
        })
        .on('touchend', (e) => {
          // e.preventDefault()
          $card.find(`${this.imageSelector}--hover`).css('opacity', '0')
        })
      if ($card.is('a')) {
        $card.attr('href', $el.attr('data-href'))
      }
      $card
        .on('focusin', (e) => {
          // e.preventDefault()
          $card.find(`${this.imageSelector}--hover`).css('opacity', '1')
        })
        .on('focusout', (e) => {
          // e.preventDefault()
          $card.find(`${this.imageSelector}--hover`).css('opacity', '0')
        })
      $card.find('a').attr('href', $el.attr('data-href'))
      $card.find('.cProductCard-flag').html($el.attr('data-flag'))
      $card.find(`${this.selector}-price`).html($el.attr('data-price'))
      $card.find(this.subtitleSelector).text($el.attr('data-subtitle'))
      $card.find(this.variantSelector).removeClass('active')
      $card.find(this.variantSelector).attr('aria-checked', 'false')

      if (tag) {
        $card.find('.cProductCard-tag').text(tag).show()
      } else {
        $card.find('.cProductCard-tag').hide()
      }

      $el.addClass('active')
      $el.attr('aria-checked', 'true')
      updateAllCurrencies()
    })
    this.$document.find(this.variantSelector).each((i, el) => {
      const $el = $(el)
      const hammertime = new Hammer($(el).get(0), {})
      hammertime.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
      hammertime.on('swipeleft swiperight', (ev) => {
        const $carousel = $(ev.target).closest(this.selector)
        $carousel.find(`${selector}-nav--${ev.type === 'swiperight' ? 'prev' : 'next'}`).trigger('click')
      })
    })
    this.$document.find(this.variantSelector).on('keypress', (e) => {
       e.preventDefault();
       var searchkey = e.which;
       const $el = $(e.currentTarget);
       const $card = $el.closest(this.selector);
       if(searchkey == 13)  // the enter key code
        {
          $el.click();
          return false;  
        }
    });
    this.$document.on('keydown', '.cProductCard-variants[role="radiogroup"]', (e) => {
      const $group = $(e.currentTarget);
      const $swatches = $group.children('.cProductCard-variant');
      if (!$swatches.length) return;

      const $focused = $swatches.filter(':focus');
      let index = $swatches.index($focused);

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        index = index < $swatches.length - 1 ? index + 1 : 0;
        $swatches.attr('tabindex', '-1');
        $swatches.eq(index).attr('tabindex', '0').focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        index = index > 0 ? index - 1 : $swatches.length - 1;
        $swatches.attr('tabindex', '-1');
        $swatches.eq(index).attr('tabindex', '0').focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $swatches.filter(':focus').trigger('click');
      }
    });
    this.$document.find(this.navSelector).on('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      const $el = $(e.currentTarget)
      $el.blur()
      const direction = $el.is(`${this.selector}-nav--next`) ? 'next' : 'prev'
      const $card = $el.closest(this.selector)
      let $variants = $card.find(this.variantSelector)
      if (direction === 'next') {
        $variants.first().insertAfter($variants.last())
      } else {
        $variants.last().insertBefore($variants.first())
      }
      $variants = $card.find(this.variantSelector)
      if ($variants.first().attr('data-index') * 1 === 0) {
        $card.find(`${selector}-variants`).attr('data-index', 'first')
      } else if ($variants.first().attr('data-index') * 1 === ($variants.length - 6)) {
        $card.find(`${selector}-variants`).attr('data-index', 'last')
      } else {
        $card.find(`${selector}-variants`).attr('data-index', $variants.first().attr('data-index'))
      }
    })
    this.$document.find(this.variantSelector).filter(':first-child').trigger('click')
  }
}

const Video = {
  init($document, selector = '[data-video-url*="vimeo"],[data-video-url*="youtube"],[data-video-url*="youtu.be"]') {
    window.xyz = this
    this.$el = $document.find(selector)
    this.$el.on('click', (e) => {
      const $this = $(e.currentTarget)
      try {
        let embedUrl = ''
        if ($this.is('[href*="vimeo"]')) {
          embedUrl = `https://player.vimeo.com/video/${this.getVimeoId($this.attr('href'))}?autoplay=1&loop=0&title=0&byline=0&portrait=0`
        } else {
          embedUrl = `https://www.youtube.com/embed/${this.getYoutubeId($this.attr('href'))}?autoplay=1&loop=0&rel=0&showinfo=0`
        }

        const $modal = this.createModal(embedUrl)
        $modal.hide()
        $modal.appendTo($('body'))
        $modal.fadeIn('fast')
        let top = $(window).scrollTop()
        $modal.find('label').on('click', (ev) => {
          top = $(window).scrollTop()
        })
        $modal.find('.cModal-toggler').on('change', (ev) => {
          const $check = $(ev.currentTarget)
          if (!$check.is(':checked')) {
            setTimeout(() => {
              $modal.remove()
            }, 500)
          }
          $(window).scrollTop(top)

        })
        e.preventDefault()
      } catch (exception) {
        console.log('Could not load video', exception)
      }
    })
  },
  createModal(embedUrl) {
    const dialogId = `cModal_${(new Date()).getTime()}`
    const markup = `
      <div class="cModalContainer cModalContainer--vimeo">
        <input type="checkbox" class="cModal-toggler" id="${dialogId}" />
        <div class="cModal cModal--lg cModal--video">
          <label for="${dialogId}" class="cModal-backdrop"></label>
          <div class="cModal-window">
            <label for="${dialogId}" class="cModal-close">&times;</label>
            <div class="cModal-content">
              <div class="cModal-title"></div>
              <div class="cModal-video">
                <iframe src="${embedUrl}"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>`

    const $dialog = $(markup)
    console.log('DIALOG', $dialog, $dialog.find('.cModal-toggler'))
    $dialog.find('.cModal-toggler').prop('checked', true)


    if ($dialog != null) {
      $dialog.remove()
    }
    return $dialog
  },
  getVimeoId(url) {
    const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
    const parseUrl = regExp.exec(url)
    return parseUrl[5]
  },
  getYoutubeId(url) {
    // eslint-disable-next-line
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
    const match = url.match(regExp)
    return (match && match[7].length === 11) ? match[7] : false
  }
}

$(function() {
  Video.init($(document))
  Carousel.init($(document))
  RecentlyViewed.init($(document))
  MiniCart.init($(document))
  ProductCard.init($(document))
  Collection.init($(document))
  AnimaScroll.init('[data-animascroll],.lazyload')

  $('.bag-icon > a').on('click', (e) => {
    e.preventDefault()
    $('#cSideCart-toggle').trigger('click')
  })
});

window['213a'] = {
  webcam: Webcam
}


$(function() {
  var $overlay = $("#newsletter-popup");
  var $content = $("#newsletter-popup .content");

  var $cancel = $("#newsletter-popup .content .cancel");
  var now = new Date()
  var lastSeen = localStorage.getItem('alreadyClicked')
  if (lastSeen && (lastSeen * 1 + 60*60*4*1000 ) <= now.getTime()) {
    localStorage.removeItem('alreadyClicked')
  }
  $(window).on('scroll', () => {
    const percent = ($(window).height() + $(window).scrollTop()) / $('body').height()
    if (percent >= 0.33) {
      if (!localStorage.getItem('alreadyClicked')) {
        $overlay.addClass("show");
        localStorage.setItem('alreadyClicked', now.getTime());
      }
    }
  })
  setTimeout(
    function(){
      if (!localStorage.getItem('alreadyClicked')) {
        $overlay.addClass("show");
        localStorage.setItem('alreadyClicked', now.getTime());
      }
    }, 10000);

  $overlay.click(function() {
    $overlay.removeClass("show")
  });

  $cancel.click(function() {
    $overlay.removeClass("show")
  });

  $content.click(function(e) {
    e.stopPropagation();
  });
});

window.geolocate = async (refresh = false) => {
  const storageKey = 'geolocation';

  if (!refresh) {
    const location = sessionStorage.getItem(storageKey);

    if (location) {
      try {
        return JSON.parse(location);
      } catch(e) {
        console.warn('geolocate: Malformed location data', e);
      }
    }
  }

  const req = await fetch(`https://api.ipstack.com/check?access_key=6fa4377d6fb19c624ad7931d07b8a419`);
  const resp = await req.json();
  sessionStorage.setItem(storageKey, JSON.stringify(resp));

  return resp;
}

// Cookie Banner
(async () => {
  const storageKey = 'cookieConsent';
  const consent = sessionStorage.getItem(storageKey);

  if (!consent) {
    const location = await geolocate();

    if (location && location.country_code == 'US' && location.region_code == 'CA') {
      const bannerEl = document.createElement('div');
      bannerEl.classList.add('cookies');
      bannerEl.innerHTML = `
        <p>${theme.strings.cookies.message}</p>
        <button type="button">${theme.strings.cookies.accept}</button>
      `;

      // Close banner on click
      bannerEl.querySelector('button').addEventListener('click', () => {
        bannerEl.classList.remove('is-visible');
        sessionStorage.setItem(storageKey, 'closed');
      });

      document.body.appendChild(bannerEl);
      setTimeout(() => {
        bannerEl.classList.add('is-visible');
      }, 2000);
    }
  }
})();

// Geolocation Banner
(async () => {
  if (window.Shopify.shop == 'illesteva-dev.myshopify.com') {
    const storageKey = 'geoBanner';
    const geoBanner = sessionStorage.getItem(storageKey);

    if (!geoBanner) {
      const location = await geolocate();

      function buildModal() {
        const { settings } = window.sections.geolocation;
        const modalEl = document.createElement('section');
        modalEl.classList.add('geolocation');
        modalEl.setAttribute('aria-hidden', true);
        modalEl.innerHTML = `
          <div class="geolocation__content">
            <h2 class="geolocation__title">${settings.heading}</h2>
            <p class="geolocation__tagline">${settings.tagline.replace('[country]', location.country_name)}</p>
            <hr/>
            <ul class="geolocation__options">
              <li class="geolocation__option">
                <div class="geolocation__flag">
                  <span class="geolocation__emoji">🇺🇸</span>
                  <p class="geolocation__text">${settings.us_text}</p>
                  <button class="geolocation__cta animatable js-modal-close">${settings.us_cta}</button>
                </div>
              </li>
              <li class="geolocation__option">
                <div class="geolocation__flag">
                  <span class="geolocation__emoji">🇪🇺</span>
                  <p class="geolocation__text">${settings.eu_text}</p>
                  <a href="${settings.eu_url}" class="geolocation__cta animatable">${settings.eu_cta}</a>
                </div>
              </li>
            </ul>
            <hr/>
          </div>
        `;

        modalEl.querySelectorAll('.js-modal-close').forEach(el => {
          el.addEventListener('click', () => {
            sessionStorage.setItem(storageKey, 'closed');
            modalEl.setAttribute('aria-hidden', true);
          });
        });

        document.body.appendChild(modalEl);

        setTimeout(() => {
          modalEl.setAttribute('aria-hidden', false);
        }, 1500);
      }

      if (location.continent_code == 'EU') {
        buildModal();
      }
    }
  }
})();

